import { FC } from "react";

import { useCartDocument } from "@hooks/useCartDocument";

import Skeleton from "@mui/material/Skeleton";
import DocumentDetails from "../DocumentDetails";

import { ISingleDocumentProperties } from "./SingleDocument.types";

const SingleDocument: FC<ISingleDocumentProperties> = ({ documentId }) => {
  const { document, isLoading: isDocumentLoading } = useCartDocument(documentId);

  if (isDocumentLoading) {
    return <Skeleton variant="rounded" width={180} height={32} />;
  }

  if (document == null) {
    return null;
  }

  return <DocumentDetails document={document} />;
};

export default SingleDocument;
